// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5809":"fc141dc5","8076":"53e8dc10"}[chunkId] + ".chunk.css";
};